import React from 'react';
import moment from 'moment';

import { WithStyles, withStyles, createStyles, useMediaQuery } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { useTheme } from '@material-ui/core/styles';

import ArrowLeft from '../Common/Icons/ArrowLeft';
import ArrowRight from '../Common/Icons/ArrowRight';
import BookingDatePicker from '../Common/DatePickers/BookingDatePicker';
import { Theme } from "@material-ui/core/styles";
import classNames from "classnames";

const styles = (theme: Theme) => createStyles({
  wrap: {
    width: '100%',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    minWidth: 0, // Позволяет flex-элементам сжиматься, но не меньше их контента

    [theme.breakpoints.down(480)]: {
      width: "auto"
    },
  },
  marginRight: {
    marginRight: 20,
    [theme.breakpoints.down(1200)]: {
      marginRight: 12,
    },
    [theme.breakpoints.down(600)]: {
      marginRight: 8,
    },
    // Уменьшаем отступы на мобильных для компактности
    [theme.breakpoints.down(465)]: {
      marginRight: 2, // Минимальный отступ
    },
  },
  marginLeft: {
    marginLeft: 20,
    [theme.breakpoints.down(1200)]: {
      marginRight: 12,
    },
    [theme.breakpoints.down(600)]: {
      marginRight: 8,
    },
    // Уменьшаем отступы на мобильных для компактности
    [theme.breakpoints.down(465)]: {
      marginRight: 2, // Минимальный отступ
    },
  },
  textCenter: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  iconButton: {
    // Компактные кнопки на мобильных
    [theme.breakpoints.down(600)]: {
      padding: 4, // Еще меньше padding
      '& svg': {
        fontSize: 16, // Еще меньше иконки
      },
    },
  },
});

interface IProps extends WithStyles {
  currentStatisticDate: string;
  handleChangeDate: (d: any) => void;
}

const BookingDate: React.FC<IProps> = (props) => {
  const {
    classes,
    currentStatisticDate,
    handleChangeDate,
  } = props;

  /** @description Переключение даты */
  const onChangeDate = (type: number) => {
    let newDate = null;

    switch (type) {
      case 0: {
        newDate = moment(currentStatisticDate)
        .subtract(1, 'days')
        .format();
        break;
      }
      case 1: {
        newDate = moment(currentStatisticDate)
        .add(1, 'days')
        .format();
        break;
      }
      default: {
        newDate = currentStatisticDate;
      }
    }

    handleChangeDate(newDate);
  };

  // Определяем, является ли устройство мобильным
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  return (
    <div className={classes.wrap}>
      <IconButton
        onClick={() => onChangeDate(0)}
        className={classNames(classes.marginRight, classes.iconButton)}
        size={isMobile ? 'small' : 'medium'}
      >
        <ArrowLeft />
      </IconButton>
      <BookingDatePicker
        handleChangeDate={handleChangeDate}
        currentStatisticDate={currentStatisticDate}
      />
      <IconButton
        onClick={() => onChangeDate(1)}
        className={classNames(classes.marginLeft, classes.iconButton)}
        size={isMobile ? 'small' : 'medium'}
      >
        <ArrowRight />
      </IconButton>
    </div>
  );
};

export default withStyles(styles)(BookingDate);
